var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailEnvelope24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 5h12a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V8a3 3 0 013-3z",
    id: "mail-envelope-24_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mail-envelope-24_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mail-envelope-24_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M18 5.75c.621 0 1.184.252 1.591.659.407.407.659.97.659 1.591h0v8c0 .621-.252 1.184-.659 1.591-.407.407-.97.659-1.591.659h0H6a2.243 2.243 0 01-1.591-.659A2.243 2.243 0 013.75 16h0V8c0-.621.252-1.184.659-1.591.407-.407.97-.659 1.591-.659h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14l9-6v8a3 3 0 01-3 3H6a3 3 0 01-3-3V8l9 6z",
    fillOpacity: 0.15,
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#mail-envelope-24_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    mask: "url(#mail-envelope-24_svg__b)",
    d: "M3 8l9 6 9-6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailEnvelope24);
export default __webpack_public_path__ + "static/media/mail-envelope-24.5f090ce7.svg";
export { ForwardRef as ReactComponent };